import React from "react";
const FormStepContext = React.createContext(null);
const FormStepProvider = ({ steps, children }) => {
    const value = React.useMemo(() => ({ steps }), [steps]);
    return (React.createElement(FormStepContext.Provider, { value: value }, children));
};
export const useFormStepProvider = () => React.useContext(FormStepContext);
export default FormStepProvider;
//# sourceMappingURL=index.js.map